var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-field',{ref:"field",attrs:{"has-error":_vm.hasError,"error-label":_vm.errorLabel,"helper":_vm.helper,"label":_vm.label}},[_c('vue-code-diff',{attrs:{"old-string":_vm.oldValue,"new-string":_vm.newValue,"context":4,"output-format":"side-by-side"}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e724a3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/form/VDiff.vue
// module id = wOSM
// module chunks = 44